import Vue from 'vue'
import { COIN_TYPE } from '../constants/index'
/**
 * 毫秒值 转换成 年月日
 * @param  {Date}   value) {               let time [description]
 * @return {[type]}        [description]
 */
Vue.filter('time-formater-no-hour', (value) => {
  if (!value) {
    return ''
  }
  // 返回处理后的值
  let time = new Date(parseInt(value))
  let year = time.getFullYear()
  let month = (time.getMonth() < 9 ? '0' : '') + (time.getMonth() + 1)
  let day = (time.getDate() < 10 ? '0' : '') + time.getDate()
  return year + '-' + month + '-' + day
})
Vue.filter('time-formater-has-hour', (value) => {
  if (value instanceof Array) {
    if (!value[0]) { return value[1] }
    value = value[0]
  }
  if (!value) { return '' }
  let time = new Date(value)
  let year = time.getFullYear()
  let month = (time.getMonth() < 9 ? '0' : '') + (time.getMonth() + 1)
  let day = (time.getDate() < 10 ? '0' : '') + time.getDate()
  let hour = (time.getHours() < 10 ? '0' : '') + time.getHours()
  let minute = (time.getMinutes() < 10 ? '0' : '') + time.getMinutes()
  let second = (time.getSeconds() < 10 ? '0' : '') + time.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
})
Vue.filter('currency-unit', value => {
  if (!value) return ''
  return COIN_TYPE[value]
})
